export default __webpack_public_path__ + "static/media/woman-supervillain-medium-skin-tone_1f9b9-1f3fd-200d-2640-fe0f.0d365c20.png";